import { t } from '@lingui/core/macro';
import { Box, Chip } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { SidebarMenuBody } from 'app/domains/common-ui';
import { useCompanyFeatures } from 'app/domains/companies/features/CompanyFeatures';
import { MetadataNotifications } from 'app/domains/metadata';
import { useFeatureFlag } from 'shared/domains/featureFlag';
import { BackOffice } from './BackOffice';
import { CollapsibleDocuments } from './CollapsibleDocuments';
import { CollapsibleInsights } from './CollapsibleInsights';
import { CollapsibleSavedViews } from './CollapsibleSavedViews';
import { CollapsibleSettings } from './CollapsibleSettings';
import { ItemLink } from './ItemLink';
import { UserGuidingButton } from './UserGuidingButton';
export function Body() {
    const orcaEditor = useFeatureFlag('feature_orca_editor');
    const actionCentre = useFeatureFlag('feature_action_centre');
    const { isFeatureAvailable } = useCompanyFeatures();
    const agent = isFeatureAvailable('AGENT');
    const globalPlai = isFeatureAvailable('PLAI_AGENT');
    const showProjects = isFeatureAvailable('PROJECTS');
    return (<SidebarMenuBody>
      {agent && (<ItemLink to="/agent" icon={<Falcon icon="sparkles"/>} label={t({
                comment: 'Sidebar menu - Agent label',
                message: 'Agent',
                context: 'sidebar',
            })} matchPath={['/agent']}/>)}
      {/* Companies migrated to the agent lose access to PLAI */}
      {!agent && globalPlai && (<ItemLink to="/plai/chat" icon={<Falcon icon="sparkles"/>} adornmentRight={<Box pr="md">
              <Chip appearance="secondary" size="small" label="BETA"/>
            </Box>} label={t({
                comment: 'Sidebar menu - Global PLAI label',
                message: 'PLAI',
                context: 'sidebar',
            })} matchPath={['/plai']}/>)}
      <ItemLink matchExact to="/dashboard" icon={<Falcon icon="grid-2"/>} label={t({ comment: 'Sidebar menu - Dashboard label', message: 'Dashboard', context: 'sidebar' })} matchPath={['/dashboard', '/documents/*']}/>
      {showProjects && (<ItemLink to="/projects" icon={<Falcon icon="rectangle-history"/>} label={t({ comment: 'Sidebar menu - Projects label', message: 'Projects', context: 'sidebar' })} matchPath={['/projects', '/projects/:projectId']}/>)}
      {actionCentre && (<ItemLink to="/action-centre" icon={<Falcon icon="inbox"/>} label={t({ comment: 'Sidebar menu - Action centre label', message: 'Action centre' })} matchPath={['/action-centre']}/>)}
      <CollapsibleDocuments />
      <CollapsibleInsights />
      <CollapsibleSavedViews />
      <ItemLink to="/tasks" icon={<Falcon icon="list-check"/>} label={t({ comment: 'Sidebar menu - Tasks label', message: 'Tasks', context: 'sidebar' })} matchPath={['/tasks']}/>
      <ItemLink to="/contracts" icon={<Falcon icon="pen-to-square"/>} label={t({ comment: 'Sidebar menu - Templates label', message: 'Templates', context: 'sidebar' })} matchPath={['/contracts']}/>
      {orcaEditor && (<ItemLink to="/templates/create" icon={<Falcon icon="whale"/>} label={t({ comment: 'Sidebar menu - Orca editor label', message: 'Orca editor', context: 'sidebar' })} matchPath={['/templates/create']}/>)}
      <CollapsibleSettings />
      <BackOffice />
      <MetadataNotifications />
      <UserGuidingButton />
    </SidebarMenuBody>);
}
